<template>
  <div>
    <DrawerContainer
      ref="drawerContainer"
      :dialogShow="dialogShow"
      v-if="dialogShow"
      :dialog-width="'40%'"
      title="客服代下单"
      :saveBtnTxt="'下一步'"
      @resetPopupData="dialogShow = false"
      @submitPopupData="submitForm">
      <div class="order-box custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <div class="right-title">
            <el-image :src="cheImage" class="title-label"></el-image>
            发货方
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="代理商名称" prop="companyId">
                <el-select style="width: 100%" v-model="form.companyId" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in agentData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发货人" prop="userId">
                <el-select style="width: 100%" v-model="form.userId" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in userData"
                    :key="item.userId"
                    :label="item.username+'-'+item.phone"
                    :value="item.userId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="装货时间" prop="startLoadTime">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.startLoadTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="请选择装货时间"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="right-title">
            <el-image :src="cheImage" class="title-label"></el-image>
            货物信息
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="货物名称" prop="cargo.cargoName">
                <el-input
                  v-model="form.cargo.cargoName"
                  clearable
                  autocomplete="off"
                  maxlength="30"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="包装方式" prop="cargo.packingWays">
                <el-select
                  style="width: 100%"
                  v-model="form.cargo.packingWays"
                  filterable
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in getConfig('packing_way')"
                    :key="item.dictLabel"
                    :label="item.dictLabel"
                    :value="item.dictLabel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="custom-form-label">
              <el-form-item label="货物体积/重量" prop="cargo.byPiece" label-position="left">
                <el-switch v-model="form.cargo.byPiece" active-color="#13ce66"></el-switch>
                <span class="unit">件装</span>
              </el-form-item>
            </el-col>
            <template v-if="form.cargo.byPiece">
              <el-col :span="24" class="bg-common">
                <el-col :span="24" class="bg-common-1">
                  <el-col :span="12" class="custom-form-input">
                    <div class="custom-label">单件体积（单位 米）</div>
                    <div class="custom-input-box">
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item prop="cargo.cargoLength">
                            <el-input
                              v-model="form.cargo.cargoLength"
                              clearable
                              autocomplete="off"
                              maxlength="30"
                              placeholder="请输入长" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="cargo.cargoWidth">
                            <el-input
                              v-model="form.cargo.cargoWidth"
                              clearable
                              autocomplete="off"
                              maxlength="30"
                              placeholder="请输入宽" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="cargo.cargoHeight">
                            <el-input
                              v-model="form.cargo.cargoHeight"
                              clearable
                              autocomplete="off"
                              maxlength="30"
                              placeholder="请输入高" />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="12" class="custom-form-input">
                    <div class="custom-label">件数</div>
                    <el-form-item prop="cargo.piece">
                      <el-input
                        v-model="form.cargo.piece"
                        clearable
                        style="width: 100%"
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入">
                        <span slot="suffix">件</span>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-col>
            </template>
            <template v-else>
              <el-col :span="24" class="bg-common">
                <el-col :span="24" class="bg-common-1">
                  <el-col :span="12" class="custom-form-input">
                    <div class="custom-label">货物体积（单位 米）</div>
                    <div class="custom-input-box">
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item prop="cargo.cargoLength">
                            <el-input
                              v-model="form.cargo.cargoLength"
                              clearable
                              autocomplete="off"
                              maxlength="30"
                              placeholder="请输入长" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="cargo.cargoWidth">
                            <el-input
                              v-model="form.cargo.cargoWidth"
                              clearable
                              autocomplete="off"
                              maxlength="30"
                              placeholder="请输入宽" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="cargo.cargoHeight">
                            <el-input
                              v-model="form.cargo.cargoHeight"
                              clearable
                              autocomplete="off"
                              maxlength="30"
                              placeholder="请输入高" />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <!--                  </template>-->
                  <!--                  <template v-if="isWeight">-->
                  <el-col :span="12" class="custom-form-input">
                    <div class="custom-label">
                      <div>货物重量</div>
                      <div class="label">
                        <el-radio-group v-model="form.cargo.wightUnit">
                          <el-radio :label="1">吨</el-radio>
                          <el-radio :label="2">公斤</el-radio>
                        </el-radio-group>
                      </div>
                    </div>
                    <el-form-item prop="cargo.weight">
                      <el-input
                        v-model="form.cargo.weight"
                        clearable
                        style="width: 100%"
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <!--                  </template>-->
                </el-col>
              </el-col>
            </template>
          </el-row>
          <div class="right-title">
            <el-image :src="cheImage" class="title-label"></el-image>
            运输路线
          </div>
          <el-row>
            <el-col :span="14">
              <el-form-item label="" prop="lineId">
                <el-select style="width: 100%" v-model="form.lineId" filterable placeholder="请选择运输路线">
                  <el-option
                    v-for="item in lineData"
                    :key="item.lineId"
                    :label="`${item.startProvinceName}${item.startCityName}-${item.endProvinceName}${item.endCityName}`"
                    :value="item.lineId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="line-box">
            <div class="line-box-list" v-for="(item, index) in form.dress">
              <div class="line-list-left">
                <div class="line-left-top">
                  <div class="line-left-top-img-box">
                    <el-image :src="zhuangImage" class="line-left-top-left"></el-image>
                  </div>
                  <div class="line-left-top-right">
                    <div class="city-box">
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item :prop="'dress.' + index + '.provinceCode'" :rules="rules.provinceCode">
                            <el-select
                              style="width: 100%"
                              disabled
                              v-model="item.provinceCode"
                              filterable
                              placeholder="请选择">
                              <el-option
                                v-for="item in getAllProvinces()"
                                :key="item.areaCode"
                                :label="item.areaExtName"
                                :value="item.areaCode"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item :prop="'dress.' + index + '.cityCode'" :rules="rules.cityCode">
                            <el-select
                              style="width: 100%"
                              disabled
                              v-model="item.cityCode"
                              filterable
                              placeholder="请选择">
                              <el-option
                                v-for="item in getCitiesByProvinceCode(item.provinceCode)"
                                :key="item.areaCode"
                                :label="item.areaExtName"
                                :value="item.areaCode"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item :prop="'dress.' + index + '.districtCode'" :rules="rules.districtCode">
                            <el-select
                              style="width: 100%"
                              @change="changeDistrictCode($event, getDistrictsByCityCode(item.cityCode), item.districtCode, 'dress', index)"
                              v-model="item.districtCode"
                              filterable
                              placeholder="请选择区县">
                              <el-option
                                v-for="item in getDistrictsByCityCode(item.cityCode)"
                                :key="item.areaCode"
                                :label="item.areaExtName"
                                :value="item.areaCode"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="address-box">
                      <el-form-item :prop="'dress.' + index + '.address'" :rules="rules.address">
                        <el-input
                          v-model="item.address"
                          clearable
                          :disabled="!item.lng"
                          autocomplete="off"
                          maxlength="300"
                          placeholder="请点击定位按钮选择地址">
                          <div slot="append" @click="selectLntAndLot('dress', item, index)">
                            <i class="el-icon-map-location"></i>
                          </div>
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="line-left-bottom">
                  <div class="line-left-bottom-list">
                    <div class="left-txt">装货联系人：</div>
                    <div class="right-input">
                      <el-form-item
                        :prop="'dress.' + index + '.linkUsername'"
                        :rules="rules.linkUsername"
                        style="width: 100%">
                        <el-input
                          v-model="item.linkUsername"
                          clearable
                          style="width: 100%"
                          autocomplete="off"
                          maxlength="30"
                          placeholder="请输入联系人姓名"></el-input>
                      </el-form-item>
                      <el-form-item
                        :prop="'dress.' + index + '.linkPhone'"
                        :rules="rules.linkPhone"
                        style="margin-left: 0.1rem; width: 100%">
                        <el-input
                          v-model="item.linkPhone"
                          clearable
                          style="width: 100%"
                          autocomplete="off"
                          maxlength="11"
                          placeholder="请输入联系人电话"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="index === 0">
                <div class="line-list-right">
                  <el-image :src="jiaImage" class="jia-img" @click="add('dress', item, index)"></el-image>
                  <div class="jia-txt" @click="add('dress', item, index)">加装货地</div>
                </div>
              </template>
              <template v-if="index > 0">
                <div class="line-list-right">
                  <el-image :src="jianImage" class="jia-img" @click="del('dress', item, index)"></el-image>
                  <div class="jia-txt" @click="del('dress', item, index)">删除</div>
                </div>
              </template>
            </div>
            <div class="line-box-list" v-for="(item, index) in form.unload">
              <div class="line-list-left">
                <div class="line-left-top">
                  <div class="line-left-top-img-box">
                    <el-image :src="xieImage" class="line-left-top-left"></el-image>
                  </div>
                  <div class="line-left-top-right">
                    <div class="city-box">
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item :prop="'unload.' + index + '.provinceCode'" :rules="rules.provinceCode">
                            <el-select
                              style="width: 100%"
                              disabled
                              v-model="item.provinceCode"
                              filterable
                              placeholder="请选择">
                              <el-option
                                v-for="item in getAllProvinces()"
                                :key="item.areaCode"
                                :label="item.areaExtName"
                                :value="item.areaCode"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item :prop="'unload.' + index + '.cityCode'" :rules="rules.cityCode">
                            <el-select
                              style="width: 100%"
                              disabled
                              v-model="item.cityCode"
                              filterable
                              placeholder="请选择">
                              <el-option
                                v-for="item in getCitiesByProvinceCode(item.provinceCode)"
                                :key="item.areaCode"
                                :label="item.areaExtName"
                                :value="item.areaCode"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item :prop="'unload.' + index + '.districtCode'" :rules="rules.districtCode">
                            <el-select
                              style="width: 100%"
                              v-model="item.districtCode"
                              @change="changeDistrictCode($event, getDistrictsByCityCode(item.cityCode), item.districtCode, 'unload', index)"
                              filterable
                              placeholder="请选择区县">
                              <el-option
                                v-for="item in getDistrictsByCityCode(item.cityCode)"
                                :key="item.areaCode"
                                :label="item.areaExtName"
                                :value="item.areaCode"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="address-box">
                      <el-form-item :prop="'unload.' + index + '.address'" :rules="rules.address">
                        <el-input
                          v-model="item.address"
                          clearable
                          :disabled="!item.lng"
                          autocomplete="off"
                          maxlength="300"
                          placeholder="请点击定位按钮选择地址">
                          <div slot="append" @click="selectLntAndLot('unload', item, index)">
                            <i class="el-icon-map-location"></i>
                          </div>
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="line-left-bottom">
                  <div class="line-left-bottom-list">
                    <div class="left-txt">卸货联系人：</div>
                    <div class="right-input">
                      <el-form-item
                        :prop="'unload.' + index + '.linkUsername'"
                        :rules="rules.linkUsername"
                        style="width: 100%">
                        <el-input
                          v-model="item.linkUsername"
                          clearable
                          style="width: 100%"
                          autocomplete="off"
                          maxlength="30"
                          placeholder="请输入联系人姓名"></el-input>
                      </el-form-item>
                      <el-form-item
                        :prop="'unload.' + index + '.linkPhone'"
                        :rules="rules.linkPhone"
                        style="margin-left: 0.1rem; width: 100%">
                        <el-input
                          v-model="item.linkPhone"
                          clearable
                          style="width: 100%"
                          autocomplete="off"
                          maxlength="11"
                          placeholder="请输入联系人电话"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="index === 0 && form.unload.length > 1">
                <div class="line-list-right">
                  <el-image :src="jianImage" class="jia-img" @click="del('unload', item, index)"></el-image>
                  <div class="jia-txt" @click="del('unload', item, index)">删除</div>
                </div>
              </template>
              <template v-if="index > 0 || form.unload.length === 1">
                <div class="line-list-right">
                  <el-image :src="jiaImage" class="jia-img" @click="add('unload', item, index)"></el-image>
                  <div class="jia-txt" @click="add('unload', item, index)">加卸货地</div>
                </div>
              </template>
            </div>
          </div>
          <div class="right-title">
            <el-image :src="cheImage" class="title-label"></el-image>
            用车要求
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="整拼方式" prop="vehicle.vehicleUseType">
                <el-select
                  style="width: 100%"
                  v-model="form.vehicle.vehicleUseType"
                  filterable
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in getConfig('vehicle_use_type')"
                    :key="item.dictLabel"
                    :label="item.dictLabel"
                    :value="item.dictLabel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车型" prop="vehicleMode">
                <el-select
                  style="width: 100%"
                  v-model="form.vehicle.vehicleMode"
                  filterable
                  clearable
                  multiple
                  collapse-tags
                  placeholder="请选择（多选）">
                  <el-option
                    v-for="item in getConfig('vehicle_mode')"
                    :key="item.dictLabel"
                    :label="item.dictLabel"
                    :value="item.dictLabel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车长" prop="vehicleLength">
                <el-select
                  style="width: 100%"
                  v-model="form.vehicle.vehicleLength"
                  filterable
                  multiple
                  collapse-tags
                  clearable
                  placeholder="请选择（多选）">
                  <el-option
                    v-for="item in getConfig('vehicle_length')"
                    :key="item.dictLabel"
                    :label="item.dictLabel + '米'"
                    :value="item.dictLabel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="right-title">
            <el-image :src="cheImage" class="title-label"></el-image>
            运单信息要求
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="发票要求" prop="needInvoice">
                <el-select style="width: 100%" v-model="form.needInvoice" clearable placeholder="请选择">
                  <el-option label="需要开票" :value="true"></el-option>
                  <el-option label="无需开票" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回单要求" prop="receiptType">
                <el-select style="width: 100%" v-model="form.receiptType" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in $dict.receiptTypeOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="form.remark"
                  clearable
                  autocomplete="off"
                  rows="3"
                  type="textarea"
                  show-word-limit
                  maxlength="50"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </DrawerContainer>
    <addPosition ref="addPosition" @positionChange="handlePositionChange"></addPosition>
    <calculatePrice ref="calculatePriceRef" @refreshData="refreshData"></calculatePrice>
  </div>
</template>

<script>
import DrawerContainer from "@/components/Drawer.vue";
import CustomCarNumber from "@/components/CustomCarNumber.vue";
import { validatePhone } from "@/utils/validate";
import { getAreaNext, setFreightId } from "@/views/commonApi";
import { getConfig } from "@/utils/localDict";
import uploadFiles4 from "@/components/UploadFiles4.vue";
import UploadFiles1 from "@/components/UploadFiles1.vue";
import addPosition from "./addPosition.vue";
import calculatePrice from "./calculatePrice.vue";
import {orderFreight, orderFreightPreFee} from "./api";
import { getRouteWithWaypoints } from "@/utils/distanceService";
import {getSelectAgent, getSelectConsigner} from "@/views/SystemManagement/AgentManagement/api";
import {getLine} from "@/views/ServiceConfig/CarrierRouteConfig/api";
export default {
  name: "AddOrEdit",
  components: {
    UploadFiles1,
    DrawerContainer,
    addPosition,
    uploadFiles4,
    calculatePrice,
    CustomCarNumber,
  },
  data() {
    return {
      isWeight: true,
      dialogShow: false,
      cheImage: require("@/assets/imgs/title.png"),
      jiaImage: require("@/assets/imgs/jia.png"),
      jianImage: require("@/assets/imgs/jian.png"),
      zhuangImage: require("@/assets/imgs/zhuang.png"),
      xieImage: require("@/assets/imgs/xie.png"),
      city3Props: {
        lazy: true,
        checkStrictly: true, //可选择任意节点
        lazyLoad(node, resolve) {
          // setTimeout(() => {
          const nodes = [];
          let query = {};
          // 构造查询条件
          if (node.value) {
            query = {
              code: node.value,
            };
          }
          //查询接口
          getAreaNext(query).then((res) => {
            res.data.map((item) => {
              let obj = {
                value: item.areaCode,
                label: item.areaName,
                leaf: item.areaLevel === 2,
                disabled: item.areaLevel <= 1,
              };
              nodes.push(obj);
            });
            //重新加载节点
            resolve(nodes);
          });
          // }, 500);
        },
      },
      form: {
        dress: [
          {
            location: [],
            address: "",
            addressBookId: "",
            cityCode: "",
            cityName: "",
            districtCode: "",
            districtName: "",
            lat: "",
            lng: "",
            endTime: "",
            linkPhone: "",
            linkUsername: "",
            loadType: 1,
            provinceCode: "",
            provinceName: "",
            startTime: "",
            tags: "",
          },
        ],
        unload: [
          {
            location: [],
            address: "",
            addressBookId: "",
            cityCode: "",
            cityName: "",
            districtCode: "",
            districtName: "",
            lat: "",
            lng: "",
            endTime: "",
            linkPhone: "",
            linkUsername: "",
            loadType: 2,
            provinceCode: "",
            provinceName: "",
            startTime: "",
            tags: "",
          },
        ],
        cargo: {
          byPiece: false,
          cargoHeight: "",
          cargoLength: "",
          cargoName: "",
          cargoWidth: "",
          // maxWeight: "",
          // minWeight: "",
          weight: "",
          packingWays: "",
          pictures: [],
          piece: "",
          wightUnit: 1,
        },
        needInvoice: false,
        sourceFee: "",
        orderId: "",
        kilometres: "", // 公里数
        companyId: "", // 代理商
        userId: "", // 发货人
        startLoadTime: "", // 装货时间
        pointList: [],
        receiptType: 0,
        remark: "",
        vehicle: {
          vehicleLength: [],
          vehicleMode: [],
          vehicleUseType: "整车",
        },
      },
      rules: {
        userId: [
          { required: true, message: "发货人不能为空", trigger: "change" },
        ],
        startLoadTime: [
          { required: true, message: "装货时间不能为空", trigger: "change" },
        ],
        companyId: [
          { required: true, message: "代理商不能为空", trigger: "change" },
        ],
        lat: [{ required: true, message: "经纬度不能为空", trigger: "change" }],
        lng: [{ required: true, message: "经纬度不能为空", trigger: "change" }],
        "cargo.cargoName": [
          { required: true, message: "货物名称不能为空", trigger: "change" },
        ],
        "cargo.packingWays": [
          { required: true, message: "包装方式不能为空", trigger: "change" },
        ],
        "vehicle.vehicleUseType": [
          { required: true, message: "整拼方式不能为空", trigger: "change" },
        ],
        needInvoice: [
          { required: true, message: "发票要求不能为空", trigger: "change" },
        ],
        receiptType: [
          { required: true, message: "回单要求不能为空", trigger: "change" },
        ],
        location: [
          { required: true, message: "省市区不能为空", trigger: "change" },
        ],
        address: [
          { required: true, message: "详细地址不能为空", trigger: "change" },
        ],
        provinceCode: [
          { required: true, message: "省不能为空", trigger: "change" },
        ],
        cityCode: [
          { required: true, message: "市不能为空", trigger: "change" },
        ],
        districtCode: [
          { required: true, message: "区县不能为空", trigger: "change" },
        ],
        "cargo.weight": [
          { required: true, message: "货物重量不能为空", trigger: "change" },
        ],
        linkUsername: [
          { required: true, message: "联系人姓名不能为空", trigger: "change" },
        ],
        linkPhone: [
          { required: true, message: "联系人电话不能为空", trigger: "change" },
        ],
        startTime: [
          { required: true, message: "开始时间不能为空", trigger: "change" },
        ],
        endTime: [
          { required: true, message: "结束时间不能为空", trigger: "change" },
        ],
        "cargo.cargoLength": [
          { required: true, message: "长不能为空", trigger: "change" },
        ],
        "cargo.cargoWidth": [
          { required: true, message: "宽不能为空", trigger: "change" },
        ],
        "cargo.cargoHeight": [
          { required: true, message: "高不能为空", trigger: "change" },
        ],
        "cargo.piece": [
          { required: true, message: "货物类型不能为空", trigger: "change" },
        ],
      },
      loading: false, // loading
      agentData: [], // 代理商
      userData: [], // 发货人
      lineData: [], // 运输路线
    };
  },
  watch: {
    isWeight: function (val) {
      if (val) {
        this.form.cargo.cargoLength = "";
        this.form.cargo.cargoWidth = "";
        this.form.cargo.cargoHeight = "";
      } else {
        this.form.cargo.weight = "";
      }
    },
    "form.companyId":function (val) {
      if (val) {
        this.getConsignerData(val)
      } else {
        this.userData = [];
        this.form.userId = ''
      }
    },
    "form.lineId": function (val) {
      this.setLocation(val)
    },
  },

  mounted() {},
  methods: {
    // 获取线路对应的省市区
    async getAreaData(cityCode) {
      let {code, data} = await getCode({
        cityCode: cityCode,
        reverse: true,
      })
      if (code === 200) {
        return data
      } else {
        return []
      }
    },
    changeDistrictCode(e, cityData, districtCode, type, index) {
      // // console.log(e, cityData, districtCode, type, index)
      if(cityData && cityData.length > 0) {
        cityData.forEach(item => {
          if (districtCode === item.areaCode) {
            this.form[type][index].districtName = item.areaName
          }
        })
      }

    },
    getAllProvinces() {
      let treeData = JSON.parse(localStorage.getItem("area"))
      // 第一级就是省，直接返回（如果有过滤需求，也可以用 areaLevel === 0 来筛选）
      return treeData.map(item => ({
        id: item.id,
        areaCode: item.areaCode,
        areaName: item.areaName,
        areaExtName: item.areaExtName
      }));
    },
    getCitiesByProvinceCode(provinceCode) {
      let treeData = JSON.parse(localStorage.getItem("area"))
      // 1. 找到对应的省节点
      const province = treeData.find(p => p.areaCode === provinceCode);
      if (!province) return [];

      // 2. 返回该省的 children（市）
      return (province.children || []).map(city => ({
        id: city.id,
        areaCode: city.areaCode,
        areaName: city.areaName,
        areaExtName: city.areaExtName,
        parentAreaCode: city.parentAreaCode
      }));
    },
    getDistrictsByCityCode(cityCode) {
      let treeData = JSON.parse(localStorage.getItem("area"))
      // 1. 遍历所有省，找到目标市所在的省，再找市节点
      let targetCity = null;
      for (const province of treeData) {
        if (!province.children) continue;
        const city = province.children.find(c => c.areaCode === cityCode);
        if (city) {
          targetCity = city;
          break;
        }
      }
      if (!targetCity) return [];

      // 2. 返回该市的 children（区/县）
      return (targetCity.children || []).map(district => ({
        id: district.id,
        areaCode: district.areaCode,
        areaName: district.areaExtName,
        areaExtName: district.areaExtName,
        parentAreaCode: district.parentAreaCode
      }));
    },
    getConfig,
    setLocation(val) {
      let lineParams = this.getItemById(val)
      // 装货
      this.form.dress.forEach(item => {
        item.location = [lineParams.startProvinceCode,lineParams.startCityCode ]
        item.provinceCode = lineParams.startProvinceCode
        item.provinceName = lineParams.startProvinceName
        item.cityCode = lineParams.startCityCode
        item.cityName = lineParams.startCityName
        item.districtCode = ""
        item.districtName = ""
        item.lat = ""
        item.lng = ""
        item.address = ""
      })
      // 卸货
      this.form.unload.forEach(item => {
        item.location = [lineParams.endProvinceCode,lineParams.endCityCode ]
        item.provinceCode = lineParams.endProvinceCode
        item.provinceName = lineParams.endProvinceName
        item.cityCode = lineParams.endCityCode
        item.cityName = lineParams.endCityName
        item.districtCode = ""
        item.districtName = ""
        item.lat = ""
        item.lng = ""
        item.address = ""
      })
    },
    getItemById(lineId) {
      return this.lineData.find(item => item.lineId === lineId);
    },
    getAgentData() {
      getSelectAgent({
        keyword: ''
      }).then(response => {
        if (response.code === 200) {
          this.agentData = response.data
        }
      })
    },
    getConsignerData(companyId) {
      getSelectConsigner({
        companyId: companyId
      }).then(response => {
        if (response.code === 200) {
          this.userData = response.data
        }
      })
    },
    getLineData(companyId) {
      getLine().then(response => {
        if (response.code === 200) {
          this.lineData = response.data
        }
      })
    },
    selectLntAndLot(type, item, index) {
      if (!item.districtCode) {
        this.$message.warning("请选择对应的区/县")
        return
      }
      this.$refs.addPosition.init(type, item, index);
    },
    handlePositionChange(obj) {
      this.form[obj.type][obj.index].lng = obj.lng;
      this.form[obj.type][obj.index].lat = obj.lat;
      this.form[obj.type][obj.index].address = obj.address;
    },
    // 增加装卸货地
    add(type, item, index) {
      if (type === "unload") {
        if (this.form[type].length < 2) {
          this.form[type].unshift({
            location: [],
            address: "",
            addressBookId: "",
            cityCode: this.form[type][0].cityCode,
            cityName: this.form[type][0].cityName,
            districtCode: "",
            districtName: "",
            endTime: "",
            linkPhone: "",
            linkUsername: "",
            loadType: item.loadType,
            provinceCode: this.form[type][0].provinceCode,
            provinceName: this.form[type][0].provinceName,
            startTime: "",
            tags: "",
          });
        }
      } else {
        if (this.form[type].length < 2) {
          this.form[type].push({
            location: [],
            address: "",
            addressBookId: "",
            cityCode: this.form[type][0].cityCode,
            cityName: this.form[type][0].cityName,
            districtCode: "",
            districtName: "",
            endTime: "",
            linkPhone: "",
            linkUsername: "",
            loadType: item.loadType,
            provinceCode: this.form[type][0].provinceCode,
            provinceName: this.form[type][0].provinceName,
            startTime: "",
            tags: "",
          });
        }
      }
    },
    // 删除装卸货地
    del(type, item, index) {
      this.form[type].splice(index, 1);
    },
    handleChange(e, type, key, dotRef) {
      const nodes = this.$refs[dotRef][0].getCheckedNodes();
      this.form[type][key].provinceName = "";
      this.form[type][key].provinceCode = "";
      this.form[type][key].cityName = "";
      this.form[type][key].cityCode = "";
      this.form[type][key].districtCode = "";
      this.form[type][key].districtName = "";
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form[type][key].provinceCode = node.value;
          this.form[type][key].provinceName = node.label;
        } else if (index === 1) {
          this.form[type][key].cityCode = node.value;
          this.form[type][key].cityName = node.label;
        } else if (index === 2) {
          this.form[type][key].districtCode = node.value;
          this.form[type][key].districtName = node.label;
        }
      });
      // // console.log("tuDot:", this.form);
    },
    init() {
      this.getLineData()
      this.getAgentData()
      this.dialogShow = true;
    },
    // 预测价格
    handlePrePrice() {
      this.$refs.drawerContainer.loading = true;
      orderFreightPreFee(this.form).then((res) => {
        if (res.code === 200) {
          this.$refs.calculatePriceRef.init(this.form, res.data)
        }
      }).finally((e) => {
        this.$refs.drawerContainer.loading = false;
      });
    },
    refreshData() {
      this.dialogShow = false
      this.$emit("refreshData");
    },
    confirmSubmit() {
      this.$confirm(`确定下单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        setFreightId().then((res) => {
          if (res.code === 200) {
            this.form.orderId = res.data;
            orderFreight(this.form)
              .then((res) => {
                this.$refs.drawerContainer.loading = false;
                if (res.code === 200) {
                  this.$confirm(
                    `<div class="dialog-confirm">
                        <div class="dialog-confirm-content">
                          <i class="custom-icon el-icon-success"></i>
                          <span class="custom-tip">下单成功</span>
                        </div>
<!--                        <div class="dialog-confirm-des">-->
<!--                          请告知货主使用下单手机号码登录拼满运微信小程序后，在小程序待支付订单页面中完成支付。-->
<!--                        </div>-->
                      </div>`,
                    "系统提示",
                    {
                      confirmButtonText: "我知道了",
                      showCancelButton: false,
                      dangerouslyUseHTMLString: true,
                      type: "none",
                      center: true,
                    }
                  ).then(() => {
                    this.dialogShow = false;
                    this.$emit("refreshData");
                  });
                }
              })
              .catch((e) => {
                this.$refs.drawerContainer.loading = false;
              });
          }
        });
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // // console.log(this.form);
          this.$refs.drawerContainer.loading = true;
          this.form.pointList = this.form.dress.concat(this.form.unload);
          let start = "";
          let end = "";
          let waypoints = [];
          this.form.pointList.forEach((item, index) => {
            if (index === 0) {
              start = `${item.lng},${item.lat}`;
            } else if (index === this.form.pointList.length - 1) {
              end = `${item.lng},${item.lat}`;
            } else {
              waypoints.push(`${item.lng},${item.lat}`);
            }
          });
          getRouteWithWaypoints(start, end, waypoints)
            .then((res) => {
              this.form.kilometres = this.$day.formatDistanceNoUnit(
                res.distance
              );
              this.handlePrePrice();
            })
            .catch(() => {
              this.handlePrePrice();
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-box {
  box-sizing: border-box;
  .right-title {
    padding: 0rem 0 0.1rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .bg-common {
    width: 100%;
    padding: 0rem 0.12rem;
    box-sizing: border-box;
    .bg-common-1 {
      width: 100%;
      padding: 0.12rem 0;
      background-color: #f7fbff;
    }
  }
  .custom-form-input {
    .custom-label {
      width: 100%;
      line-height: 0.32rem;
      font-size: 0.14rem;
      color: #57585c;
      display: flex;
      align-items: center;
      .label {
        padding-left: 0.1rem;
      }
    }
    .custom-input-box {
      display: flex;
    }
  }
  .custom-form-label {
    ::v-deep .el-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 0rem;

      .el-form-item__label {
        padding-right: 0.2rem;
      }

      .unit {
        padding-left: 0.06rem;
      }
    }
  }
  .line-box {
    .line-box-list {
      display: flex;
      margin-bottom: 0.2rem;
      ::v-deep .el-form-item {
        margin-bottom: 0.2rem;
      }
      .line-list-left {
        flex: 1;
        background: #f7fbff;
        border-radius: 0.08rem;
        padding: 0.2rem 0.2rem 0rem;
        box-sizing: border-box;
        .line-left-top {
          display: flex;
          align-items: center;
          border-bottom: 0.01rem dashed #dce5f5;
          //padding-bottom: 0.2rem;
          box-sizing: border-box;
          .line-left-top-img-box {
            width: 0.8rem;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .line-left-top-left {
              width: 0.3rem;
              height: 0.3rem;
              flex-shrink: 0;
              margin-top: -0.2rem;
            }
          }

          .line-left-top-right {
            flex: 1;

            .city-box {
              margin: 0rem 0 0.1rem;
            }
            .address-box {
            }
          }
        }
        .line-left-bottom {
          ::v-deep .el-form-item {
            margin-bottom: 0.1rem;
          }
          .line-left-bottom-list {
            display: flex;
            align-items: center;
            width: 100%;
            margin: 0.1rem 0;
            .left-txt {
              width: 1rem;
              text-align: right;
              font-size: 0.14rem;
              line-height: 0.32rem;
              flex-shrink: 0;
            }
            .right-input {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
          }
        }
      }
      .line-list-right {
        flex-shrink: 0;
        width: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-left: 0.06rem;
        box-sizing: border-box;
        .jia-img {
          width: 0.26rem;
          height: 0.26rem;
        }
        .jia-txt {
          font-size: 0.12rem;
          color: #434343;
          padding-top: 0.06rem;
        }
      }
    }
  }
  .el-icon-map-location {
    color: #1269ff;
    cursor: pointer;
  }
}
</style>
